import React from 'react';
import { states } from '@/constants/lifecycle';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import Fetch from '../hooks/fetch';

const SubscribeUserRegisteredAction = () => {
  const { isSubscribed, readStatus } = Selectors.useSubscribeUserRegisteredAction();
  const show = Events.useToggleShowSubscription();
  Fetch.useFetchSubscriptions(readStatus);

  return (
    <RibbonMenu
      className="aridhia-activity-launcher-menu"
      disabled={readStatus === states.PENDING}
      icon="eye"
      message={isSubscribed ? 'subscriptions.subscribed' : 'subscriptions.subscribe'}
      name="user-registered-subscription"
      onClick={show}
    />
  );
};

export default SubscribeUserRegisteredAction;
